<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>

        <StatisticTable :footColumns="footColumns"
                        :headColumns="headColumns"
                        :rows="rows"
                        :title="`${$t('pages.sources')}`"
                        @webGraph="webGraph">
        </StatisticTable>
        <modal effect="fade/zoom" large v-if="webid" v-model="chartModal">
            <div class="modal-header" slot="modal-header">
                <h4 class="modal-title">{{ chart.title }}</h4>
            </div>
            <div :id="`chart-container-${webid}`"></div>
            <div class="modal-footer" slot="modal-footer">
                <button @click="chartModal = false" class="btn btn-info" type="button"> {{ $t('verbs.close') }}</button>
            </div>
        </modal>
    </div>
</template>

<script>
import Filters from '../../../components/Filters'
import API from '../../../api/API'
import Storage from '../../../api/Storage'
import Helper from '../../../api/Helper'
import TypeColor from '../../../assets/TypeColor'
import { map, orderBy } from 'lodash'
import StatisticTable from '../../../components/StatisticTable.vue'
import { modal } from 'vue-strap'
import Highcharts from 'highcharts'
import getSymbolFromCurrency from 'currency-symbol-map'

export default {
  name: 'Source',
  components: {
    modal,
    Filters,
    StatisticTable
  },
  data () {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true,
        byWmFilter: true,
        byWebmasterFilter: true
      },
      chartModal: false,
      isLoading: false,
      Storage: Storage,
      TypeColor: TypeColor,
      Helper: Helper,
      webid: null,
      country: null,
      headColumns: [
        {label: this.$root.$t('pages.sources'), field: 'webmaster'},
        {label: this.$root.$t('statistic.proportion'), field: 'proportion'},
        {label: this.$root.$t('statistic.total'), field: 'total'},
        {label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2},
        {label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2},
        {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2},
        {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
        {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
        {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
        {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2},
        {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'}
      ],
      rows: [],
      footColumns: {},
      chart: {
        isBuilded: false,
        isHidden: false,
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        credits: {
          enabled: false
        },
        yAxis: [{ // --- Primary yAxis
          title: {
            text: null
          },
          tickInterval: 1
        }],
        tooltip: {
          valueSuffix: null
        },
        xAxis: {
          type: 'datetime',
          labels: {
            format: '{value:%Y-%m-%d}'
          }
        },
        series: []
      }
    }
  },
  mounted () {
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    calculateRows () {
      this.$root.$emit('data_loading')
      this.rows = []
      this.footColumns = {}
      let oldArrCurrency = []
      let newArrCurrency = []
      API.getWebmasterSourceStatistic()
          .then(response => {
            let sumTotal = 0
            const count = Object(response.data).keys.length
            // парсим тотал (для доли)
            map(response.data, (d) => {
              sumTotal += parseInt(d.total)
            })
            map(response.data, d => {
              oldArrCurrency.push(d.local_currency.split(','))
              oldArrCurrency.forEach(array => {
                array.forEach(item => {
                  newArrCurrency.push(item)
                })
              })
            })
            let filterCurrency = newArrCurrency.filter((item, index) => {
              return newArrCurrency.indexOf(item) === index
            })
            // и все остальное
            let sumProcessed = 0
            let countProcessed = 0
            let sumAccepted = 0
            let countApproved = 0
            let sumCanceled = 0
            let countCanceled = 0
            let sumError = 0
            let countError = 0
            let sumPaid = 0
            let countPaid = 0
            let sumReturn = 0
            let countReturn = 0
            let sumAverageBillLocal = 0.0
            let sumAverageBill = 0.0
            map(response.data, (d) => {
              if (d.processed > 0) {
                sumProcessed += parseInt(d.processed)
                countProcessed++
              }
              if (d.approved > 0) {
                sumAccepted += parseInt(d.approved)
                countApproved++
                sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved
                sumAverageBill += parseFloat(d.average_bill_usd) * d.approved
                this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
              }
              if (d.canceled > 0) {
                sumCanceled += parseInt(d.canceled)
                countCanceled++
              }
              if (d.error > 0) {
                sumError += parseInt(d.error)
                countError++
              }
              if (d.paid > 0) {
                sumPaid += parseInt(d.paid)
                countPaid++
              }
              if (d.return > 0) {
                sumReturn += parseInt(d.return)
                countReturn++
              }
              this.rows.push({
                source: {isCollspaned: true, value: d.source},
                proportion: {
                  value: Helper.percents(sumTotal, d.total),
                  bgg: Helper.renderSingleGist(parseInt(d.total), parseInt(d.canceled)),
                  ocb: (value) => {
                    return Helper.getRawNumber(value)
                  }
                },
                total: {
                  value: d.total,
                  bg: true,
                  webGraph: true,
                  wb: d.source
                },
                processed: {
                  value: d.processed,
                  bgg: Helper.renderGistPart(d.total, d.processed),
                  isCollspaned: true
                },
                processedPercents: {
                  value: Helper.percents(d.total, d.processed),
                  bgg: Helper.renderGistPart(d.total, d.processed, true)
                },
                accepted: {
                  value: d.approved,
                  bgg: Helper.renderGistPart(d.total, d.approved),
                  isCollspaned: true
                },
                acceptedPercents: {
                  value: Helper.percents(d.total, d.approved),
                  bgg: Helper.renderGistPart(d.total, d.approved, true),
                  webGraph: true,
                  wb: d.source,
                  webGraphSymbol: '%'
                },
                paid: {
                  value: d.paid,
                  bgg: Helper.renderGistPart(d.approved, d.paid),
                  isCollspaned: true
                },
                paidPercents: {
                  value: Helper.percents(parseInt(d.approved), parseInt(d.paid)),
                  bgg: Helper.renderGistPart(d.approved, d.paid, true),
                  webGraph: true,
                  wb: d.source,
                  webGraphSymbol: '%'
                },
                return: {
                  value: d.return,
                  bgg: Helper.renderGistPart(d.approved, d.return),
                  isCollspaned: true
                },
                returnPercents: {
                  value: Helper.percents(parseInt(d.approved), parseInt(d.return)),
                  bgg: Helper.renderGistPart(d.approved, d.return, true)
                },
                averageBill: {
                  value: '$ ' + d.average_bill_usd.toFixed(2),
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true)),
                  isCollspaned: true
                },
                averageBillLocal: {
                  value: d.local_currency.split(',').length === 1 ? `${d.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true), true)
                },
                canceled: {
                  value: d.canceled,
                  bgg: Helper.renderGistPart(d.total, d.canceled),
                  isCollspaned: true
                },
                canceledPercents: {
                  value: Helper.percents(parseInt(d.total), parseInt(d.canceled)),
                  bgg: Helper.renderGistPart(d.total, d.canceled, true)
                },
                error: {
                  value: d.error,
                  bgg: Helper.renderGistPart(d.total, d.error),
                  isCollspaned: true
                },
                errorPercents: {
                  value: Helper.percents(parseInt(d.total), parseInt(d.error)),
                  bgg: Helper.renderGistPart(d.total, d.error, true)
                },
                approvedFromValid: {
                  value: `${(d.approved_from_valid).toFixed(1)}%`
                }
              })
            })
            this.footColumns = {
              label: {
                value: this.$root.$t('statistic.in_total')
              },
              proportion: {
                value: null
              },
              total: {
                value: `${sumTotal} (${Helper.average(sumTotal, count)})`
              },
              processed: {
                value: `${sumProcessed} (${Helper.average(sumProcessed, countProcessed)})`
              },
              processedPercents: {
                value: Helper.percents(sumTotal, sumProcessed)
              },
              accepted: {
                value: `${sumAccepted} (${Helper.average(sumAccepted, countApproved)})`
              },
              acceptedPercents: {
                value: Helper.percents(sumTotal, sumAccepted)
              },
              paid: {
                value: `${sumPaid} (${Helper.average(sumPaid, countPaid)})`
              },
              paidPercents: {
                value: Helper.percents(sumAccepted, sumPaid)
              },
              return: {
                value: `${sumReturn} (${Helper.average(sumReturn, countReturn)})`
              },
              returnPercents: {
                value: Helper.percents(sumAccepted, sumReturn)
              },
              averageBill: {
                value: Helper.averageBillDayCount(sumAverageBill, sumAccepted),
                graph: {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: '$'
                }
              },
              averageBillLocal: {
                value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumAccepted, this.localCurrencySymbol) : '-',
                graph: filterCurrency.length === 1 ? {
                  cb: (value) => {
                    return Helper.getRawNumber(value)
                  },
                  symbol: this.localCurrencySymbol
                } : false
              },
              canceled: {
                value: `${sumCanceled} (${Helper.average(sumCanceled, countCanceled)})`
              },
              canceledPercents: {
                value: Helper.percents(sumTotal, sumCanceled)
              },
              error: {
                value: `${sumError} (${Helper.average(sumError, countError)})`
              },
              errorPercents: {
                value: Helper.percents(sumTotal, sumError)
              },
              approvedFromValid: {
                value: Helper.approvedFromValid(sumAccepted, sumTotal, sumError)
              }
            }
            this.$root.$emit('data_loaded')
          })
          .catch(error => {
            console.log(error)
          })
    },
    webGraph (cell, i) {
      let name = (i === 'acceptedPercents') ? 'approved' : (i === 'paidPercents') ? 'paid' : 'total'
      this.webid = cell.wb
      let approvedAll = []
      let acceptedPercentsName = this.$root.$t(`statistic.approved`)
      let totalPercentsTotal = this.$root.$t(`statistic.total`)
      let totals = this.$root.$t(`verbs.total`)
      API.getSourcesGraps(cell.wb).then(response => {
        const rows = orderBy(response.body, [function (item) {
          return item.date.value
        }], ['asc'])
        let series = []
        map(rows, (row) => {
          let value = (i === 'acceptedPercents') ? Helper.percentsF(row['total'], row['approved']) : (i === 'paidPercents') ? Helper.percentsF(row['approved'], row['paid']) : row['total']
          approvedAll[Date.parse(row.date)] = row['approved']
          series.push([Date.parse(row.date), value])
        })
        if (cell.webGraphSymbol) {
          this.chart.tooltip.valueSuffix = cell.webGraphSymbol
        } else {
          this.chart.tooltip.valueSuffix = null
        }
        this.chart.title = this.$root.$t(`statistic.${name}`)
        this.chart.series[0] = {
          data: series,
          color: TypeColor[i],
          name: this.$root.$t(`statistic.${name}`)
        }
        this.chart.yAxis[0].min = 0
        this.chart.yAxis[0].title.text = this.$root.$t(`statistic.${name}`)
        this.chart.tooltip.formatter = function () {
          if (this.series.name === acceptedPercentsName) {
            return `${this.series.name}: <b>${this.point.y} %</b><br>${totals}: <b>${approvedAll[this.x]}</b>`
          } else if (this.series.name === totalPercentsTotal) {
            return `${this.series.name}: <b>${this.point.y} </b>`
          } else {
            return `${this.series.name}: <b>${this.point.y} %</b>`
          }
        }
        Highcharts.chart(`chart-container-${this.webid}`, this.chart)
        this.chartModal = true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Source.vue?0be16096